module.exports = __webpack_public_path__ + "static/media/nutrients.7832dee6.jpg";